import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import TabsNavbar from "../Components/Common/TabsNavBar/TabsNavbar";
import RevendeurView from "./RevendeurView";
import ProspectsView from "./ProspectsView";
import ApporteurAffaires from "./ApporteurAffaires";
import { useEffect } from "react";

const PartnersView = () => {
  const [activeTab, setActiveTab] = useState("Resellers");
  const [tabs, setTabs] = useState([]);
  const { user } = useSelector((state) => state.userReducer);
  const userRole = user?.attributes?.userRole;

  useEffect(() => {
    const currentTabs =
      userRole === 2
        ? ["Resellers", "Prospects"]
        : userRole === 1
          ? ["Resellers", "Prospects", "Account Managers"]
          : [];
    setTabs(currentTabs);
    setActiveTab(currentTabs[0]);
  }, [userRole]);

  return (
    <div className="w100 d-flex flex-column gap-4 h-100">
      <TabsNavbar
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        className="gap-5"
      />
      {activeTab === "Resellers" && <RevendeurView />}
      {activeTab === "Prospects" && <ProspectsView />}
      {activeTab === "Account Managers" && <ApporteurAffaires />}
    </div>
  );
};

export default PartnersView;
